import axios from 'axios'

import { toCamelCase } from '../helpers/utils'

export interface ReferralUser {
  id: string
  email: string
  firstName: string
  lastName: string
  middleName: string
}

export interface ReferralCode {
  id: string
  campaignName: string
  dateCreated: string
  humanId: string
  isActive: boolean
  isEligibleToRefer: boolean
  mobileReferralCopy: {
    helpDocument: string
    helpDocumentTitle: string
    referralSectionContent: string
    referralSectionTitle: string
  }
  referrer: ReferralUser
  urlFacebook: string | null
  urlLinkedin: string | null
  urlTwitter: string | null
}

export interface Referral {
  dateConverted: null | string
  dateCreated: string
  dateUpdated: string
  id: string
  referralCode: ReferralCode
  referree: ReferralUser
  source: string
  status: ReferralStatus
}

export enum ReferralStatus {
  CANCELLED = 'CANCELLED',
  OPEN = 'OPEN',
  REWARDED = 'REWARDED',
  REWARD_PENDING = 'REWARD_PENDING',
  EXPIRED = 'EXPIRED',
}

export const referralStatusHuman: Record<ReferralStatus, string> = {
  [ReferralStatus.CANCELLED]: 'Canceled',
  [ReferralStatus.OPEN]: 'Open',
  [ReferralStatus.REWARDED]: 'Rewarded',
  [ReferralStatus.REWARD_PENDING]: 'Reward pending',
  [ReferralStatus.EXPIRED]: 'Expired',
}

export interface GetReferrals {
  referralCode: ReferralCode | null
  referrals: Referral[]
  referredFrom: Referral | null
}

export function getReferrals(userId: string): Promise<GetReferrals> {
  return axios.get(`/api/v3/users/${userId}/referrals/`).then((response) => {
    return toCamelCase(response.data) as GetReferrals
  })
}
